import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { GamificationData } from '../types';
import { apiRequest } from './utils/apiClient';

export const gamificationApi = {
  getGamificationData: async (
    callback: (res: GamificationData) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/gamma_dashboard/api/v0/game-profile/`;

    try {
      const data = await apiRequest<GamificationData>({
        url,
        isAuth: true,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError('Error fetching gamification data', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },
};
